export enum PointerIdentifier {
  CausingByNotItself = -1,
}
